import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";
import styled from "styled-components";
import Calendar from "../components/Calendar";
import { GetDataAll, GetData, GetEvents } from "../api";
import Layout from "../components/Layout";
import EventsTable from "@components/EventsTable";
import fp from "lodash/fp";
import Loading from "@components/Loading";
import PageContext from "@contexts/page";
import UserContext from "@contexts/user";
import { Link } from "gatsby";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr min(1110px, calc(100% - 32px)) 1fr;
  grid-row-gap: 20px;
  grid-column-gap: 16px;
  padding: 20px 0 30px;
  & > * {
    grid-column: 2;
  }
`;

const CalendarWrapper = styled.div`
  //padding: 7px;
`;

const TableWrapper = styled.div`
  .admin {
    display: none;
  }
`;

// markup
const UserPage = () => {
  const [dateStr, setDateStr] = useState("");
  const { user } = React.useContext(UserContext);

  // const { isLoading, data } = GetData();
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { countryCode } = React.useContext(PageContext);

  useEffect(() => {
    setIsLoading(true);
    GetDataAll().then(res => {
      setData(res.data);
      setIsLoading(false);
    });

    if (fp.isEmpty(user)) {
      alert(
        "둘러보기 신청을 위해서는 구글 계정 또는 정토회 계정으로 로그인해주세요. 로그인 페이지로 이동합니다."
      );
      // alert("사용자 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      navigate("/login", { state: { source: "/user" } });
    }
  }, []);

  const d = new Date();
  d.setDate(d.getDate() + 3);

  return (
    <Layout>
      <Wrapper>
        <Loading loading={isLoading} />
        <CalendarWrapper visible={true}>
          <Calendar
            year={new Date().getUTCFullYear()}
            month={new Date().getUTCMonth()}
            onClick={e => {
              const _dateStr = e.target.dataset.date || "";
              if (_dateStr !== "")
                if (new Date(_dateStr) < d) {
                  alert("둘러보기 진행일 3일 이전에만 신청 가능합니다.");
                } else {
                  setDateStr(_dateStr);
              }
            }}
            data={data?.events}
            header={""}
            // start={d}
          />
        </CalendarWrapper>
        {!isLoading && !fp.isEmpty(dateStr) && (
          <TableWrapper>
            <EventsTable
              events={data?.events}
              requests={data?.requests}
              date={dateStr}
              loading={isLoading}
              header={`일정 (${dateStr})`}
            />
          </TableWrapper>
        )}
        <Link
          to={"/mypage"}
          state={{ requests: data.requests, events: data.events }}
        >
          나의 신청 목록
        </Link>
      </Wrapper>
    </Layout>
  );
};

export default UserPage;
